export enum EnumTipoFeriado {
    Nacional = 'Nacional',
    Estadual = 'Estadual',
    Municipal = 'Municipal',
    PontoFacultativo = 'PontoFacultativo',
    Outros = 'Outros'
  }
  